import Loader from 'components/Loader';
import { useFormik } from 'formik';
import isEmpty from 'lodash/isEmpty';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import Select from 'react-select';
import { toast } from 'react-toastify';
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Row,
} from 'reactstrap';
import * as Yup from 'yup';
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import useRequest from '../../../hooks/useRequest';
import { SMKLinks } from '../../../utils/links';
import { MODULE_TYPE } from 'utils/constants';
import TextEditor from 'components/TextEditor';
import AssetImageUploader from 'containers/blog/BlogList/components/AssetImageUploader';
import SlugInput from 'components/SlugInput';

const UpdateCollegeGroups = () => {
  const history = useHistory();
  const { id: collegeGroupID } = useParams();

  toast.configure();
  const [collegeGroupsDetails, setcollegeGroupsDetails] = useState();
  const [getCollegeGroupRequest, { loading: getCollegeGroupLoading }] = useRequest({
    url: `/college/admin/collegeGroups/${collegeGroupID}`,
    method: 'GET',
    onSuccess: (data) => {
      setcollegeGroupsDetails(data);
    },
    onError: (err) => {
      toast.error(err?.message);
      console.log(err);
    },
  });

  const [addCollegeGroupRequest, { loading: addCollegeGroupLoading }] = useRequest({
    url: `/college/admin/collegeGroups`,
    method: 'POST',
    onSuccess: (data) => {
      const url = SMKLinks.COLLEGE_GROUPS;
      history.replace(url);
      toast.success('Success! College group has been added.');
    },
    onError: (err) => {
      toast.error(err?.message);
      console.log(err);
    },
  });

  const [updateCollegeGroupRequest, { loading: updateCollegeGroupLoading }] = useRequest({
    url: `/college/admin/collegeGroups/${collegeGroupID}`,
    method: 'PUT',
    onSuccess: (data) => {
      toast.success('Success! College group has been updated.');
      window.location.reload();
    },
    onError: (err) => {
      toast.error(err?.message);
      console.log(err);
    },
  });

  const editInitialValues = () => ({
    id: collegeGroupsDetails?.id,
    language: collegeGroupsDetails?.language == 1 ? { label: 'Hindi', value: 1 } : { label: 'English', value: 0 },
    isAssociation: collegeGroupsDetails?.isAssociation,
    active: collegeGroupsDetails?.active,
    deleted: collegeGroupsDetails?.deleted,
    name: collegeGroupsDetails?.name,
    shortName: collegeGroupsDetails?.shortName,
    slug: collegeGroupsDetails?.slug,
    website: collegeGroupsDetails?.website,
    description: collegeGroupsDetails?.description,
    logo: collegeGroupsDetails?.logo || {},
  });

  const getInitialValues = () => ({
    logo: {},
    id: '',
    language: { label: 'English', value: 0 },
    isAssociation: false,
    active: true,
    deleted: false,
    name: '',
    shortName: '',
    slug: '',
    website: '',
    description: '',
  });

  const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: true,
    validateOnBlur: false,
    initialValues: isEmpty(collegeGroupID) ? { ...getInitialValues() } : { ...editInitialValues() },
    onSubmit: async (values) => {
      const data = {
        logo: values?.logo?.id ? { id: values?.logo?.id } : null,
        language: values?.language?.value,
        isAssociation: values?.isAssociation,
        active: values?.active,
        deleted: values?.deleted,
        name: values?.name,
        shortName: values?.shortName,
        slug: values?.slug,
        website: values?.website,
        // summary: values?.summary,
        description: values?.description,
        // content: values?.content,
      };

      isEmpty(collegeGroupID)
        ? addCollegeGroupRequest({
            body: {
              ...data,
            },
          })
        : updateCollegeGroupRequest({
            body: {
              ...data,
            },
          });
    },
    validationSchema: Yup.object().shape({
      name: Yup.string().required('Please provide name'),
      shortName: Yup.string().required('Please provide short name'),
      slug: Yup.string().required('Please provide slug'),
      language: Yup.object()
        .required('Please provide language')
        .nullable(true),
    }),
  });

  useEffect(() => {
    if (!isEmpty(collegeGroupID)) {
      getCollegeGroupRequest();
    }
  }, [collegeGroupID]);

  return (
    <>
      <div className="page-content">
        <Loader isActive={addCollegeGroupLoading || getCollegeGroupLoading || updateCollegeGroupLoading} />
        <Container fluid>
          <Breadcrumbs
            title="College Group"
            breadcrumbItem={`${isEmpty(collegeGroupID) ? 'Add' : 'Edit'}  College Group`}
          />

          <Form onSubmit={formik.handleSubmit}>
            <Row>
              <Col md={9}>
                <Card>
                  <CardBody>
                    <Row>
                      <Col md={12}>
                        <Row>
                          <Col md={12}>
                            <FormGroup className="mb-4">
                              <Label for="language" className="form-label">
                                Language
                              </Label>
                              <Select
                                id="language"
                                options={[
                                  {
                                    value: 0,
                                    label: 'English',
                                  },
                                  {
                                    value: 1,
                                    label: 'Hindi',
                                  },
                                ]}
                                value={formik.values.language}
                                onChange={(language) => formik.setFieldValue('language', language)}
                              />
                              {formik.touched.language && (
                                <div className="invalid-feedback d-block">{formik.errors.language}</div>
                              )}
                            </FormGroup>
                          </Col>
                        </Row>
                      </Col>

                      <Col md={6}>
                        <FormGroup className="mb-4">
                          <Label for="group_name" className="form-label  ">
                            Name
                          </Label>
                          <Input
                            id="group_name"
                            name="group_name"
                            type="text"
                            className="form-control"
                            placeholder="name..."
                            invalid={!!(formik.touched.name && formik.errors.name)}
                            {...formik.getFieldProps('name')}
                          />
                          <FormFeedback>{formik.errors.name}</FormFeedback>
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup className="mb-4">
                          <Label for="shortName" className="form-label  ">
                            Short Name
                          </Label>
                          <Input
                            id="shortName"
                            name="shortName"
                            type="text"
                            className="form-control"
                            placeholder="short name..."
                            invalid={!!(formik.touched.shortName && formik.errors.shortName)}
                            {...formik.getFieldProps('shortName')}
                          />
                          <FormFeedback>{formik.errors.shortName}</FormFeedback>
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <SlugInput
                          required={true}
                          ID={collegeGroupsDetails?.name}
                          formik={formik}
                          nameValue={formik.values.name}
                          formGroupClassName={'mb-0'}
                          showResetRegenerate={true}
                          currentSlug={collegeGroupsDetails?.slug}
                        />
                      </Col>
                      <Col md={6}>
                        <FormGroup className="mb-4">
                          <Label for="website" className="form-label  ">
                            Website
                          </Label>
                          <Input
                            id="website"
                            name="website"
                            type="text"
                            className="form-control"
                            placeholder="URL..."
                            invalid={!!(formik.touched.website && formik.errors.website)}
                            {...formik.getFieldProps('website')}
                          />
                          <FormFeedback>{formik.errors.website}</FormFeedback>
                        </FormGroup>
                      </Col>
                      {/* <Col md={12}>
                        <FormGroup className="mb-4">
                          <Label for="summary" className="form-label  ">
                            Summary
                          </Label>
                          <Input
                            id="summary"
                            name="summary"
                            style={{ height: '100px' }}
                            type="textarea"
                            className="form-control"
                            placeholder="Summary..."
                            invalid={!!(formik.touched.summary && formik.errors.summary)}
                            {...formik.getFieldProps('summary')}
                          />
                          <FormFeedback>{formik.errors.summary}</FormFeedback>
                        </FormGroup>
                      </Col> */}

                      <Col md={12}>
                        <FormGroup className="mb-4">
                          <Label for="description" className="form-label">
                            Description
                          </Label>
                          <TextEditor
                            simple
                            height={200}
                            initialValue={formik.values?.description}
                            onChange={(val) => formik.setFieldValue('description', val)}
                          />

                          <FormFeedback>{formik.errors.description}</FormFeedback>
                        </FormGroup>
                      </Col>

                      {/* <Col md={12}>
                        <FormGroup className="mb-4 ">
                          <Label for="content" className="form-label  ">
                            Content
                          </Label>
                          <TextEditor
                            simple
                            height={200}
                            initialValue={formik.values?.content}
                            onChange={(val) => formik.setFieldValue('content', val)}
                          />

                          <FormFeedback>{formik.errors.content}</FormFeedback>
                        </FormGroup>
                      </Col> */}
                    </Row>
                  </CardBody>
                </Card>
              </Col>
              <Col md={3}>
                <Card>
                  <CardBody>
                    <Button type="submit" color="primary" className="w-100">
                      {isEmpty(collegeGroupID) ? 'Add' : 'Save'}
                    </Button>

                    <Button
                      className="w-100 mt-3"
                      color="light"
                      onClick={() => {
                        history.replace(SMKLinks.COLLEGE_GROUPS);
                      }}>
                      Cancel
                    </Button>
                  </CardBody>
                </Card>
                <Card>
                  <CardBody>
                    <div>
                      <CardTitle className="mb-3">Active </CardTitle>
                      {[true, false].map((option, i) => (
                        <div key={`active_${i}`} className="form-check mb-3 d-inline-block me-4">
                          <input
                            type="radio"
                            id={`active_${option}`}
                            name="babyname_active"
                            className="form-check-input"
                            checked={formik.values.active === option}
                            onChange={() => formik.setFieldValue('active', option)}
                          />
                          <label className="form-check-label" htmlFor={`active_${option}`}>
                            {option ? 'Yes' : 'No'}
                          </label>
                        </div>
                      ))}
                    </div>

                    <div>
                      <CardTitle className="mb-3">Delete </CardTitle>
                      {[true, false].map((option, i) => (
                        <div key={`deleted_${i}`} className="form-check mb-3 d-inline-block me-4">
                          <input
                            type="radio"
                            id={`deleted_${option}`}
                            name="babyname_deleted"
                            className="form-check-input"
                            checked={formik.values.deleted === option}
                            onChange={() => formik.setFieldValue('deleted', option)}
                          />
                          <label className="form-check-label" htmlFor={`deleted_${option}`}>
                            {option ? 'Yes' : 'No'}
                          </label>
                        </div>
                      ))}
                    </div>
                    <div>
                      <CardTitle className="mb-3">Is Association </CardTitle>
                      {[true, false].map((option, i) => (
                        <div key={`isAssociation_${i}`} className="form-check  d-inline-block me-4">
                          <input
                            type="radio"
                            id={`isAssociation_${option}`}
                            name="isAssociation"
                            className="form-check-input"
                            checked={formik.values.isAssociation === option}
                            onChange={() => formik.setFieldValue('isAssociation', option)}
                          />
                          <label className="form-check-label" htmlFor={`isAssociation_${option}`}>
                            {option ? 'Yes' : 'No'}
                          </label>
                        </div>
                      ))}
                    </div>
                  </CardBody>
                </Card>

                <AssetImageUploader
                  forType={MODULE_TYPE.COLLEGE}
                  formik={formik}
                  fieldName={'logo'}
                  label={'Select Logo'}
                />
              </Col>
            </Row>
          </Form>
        </Container>
      </div>
    </>
  );
};

export default UpdateCollegeGroups;
